import gql from "graphql-tag";

const MODERATION_COUNT_QUERY = gql`
    query UniversityBlockReports {
        universityBlockReportsCount(triggeredFrom: ALL, resolved: FALSE)
    }
`;

export default MODERATION_COUNT_QUERY;
